module.exports = __webpack_public_path__ + "static/media/upload_content@2x.ee020f48.png";